import { Injectable, signal } from '@angular/core';
import { LastStoreEntry, Store } from '../interfaces';
import { HttpService } from './http.service';

const MAX_LAST_STORES = 3;

@Injectable({
  providedIn: 'root',
})
export class LastStoresService {
  readonly lastStores = signal<LastStoreEntry[]>([]);
  private loaded = false;

  constructor(private http: HttpService) {}

  async get(): Promise<LastStoreEntry[]> {
    if (this.loaded) {
      return this.lastStores();
    }
    await this.loadFromApi();
    return this.lastStores();
  }

  private async loadFromApi(): Promise<void> {
    try {
      const response = await this.http.getLastStores();
      if (response.successful && response.data) {
        this.lastStores.set(response.data);
        this.loaded = true;
      }
    } catch (error) {
      console.error('Error loading last stores:', error);
    }
  }

  notifyStoreOpened(store: Store): void {
    const entry: LastStoreEntry = {
      id: store.storeId,
      name: store.name,
      lastTransactionTimestamp: Math.floor(Date.now() / 1000),
    };
    const updated = [
      entry,
      ...this.lastStores().filter((s) => s.id !== store.storeId),
    ].slice(0, MAX_LAST_STORES);
    this.lastStores.set(updated);
  }
}
